export const sortFunction = (a, b) => {
  if ((typeof a === "number") & (typeof b === "number")) {
    return a - b;
  } else {
    if (a < b) return -1;
    else if (a > b) return 1;
    else return 0;
  }
};
